export {
  RECOMMENDED_SPLIT,
  BUILD_YOUR_OWN_RISK,
  RISK_TO_PRESET_ID,
  TRAFFIC_PRESETS,
} from '../wizard-risk-split';

export const MDE_OPTIONS = [2, 3, 5, 10] as const;
export const DEFAULT_MDE = 3;

export const CUSTOM_PRODUCTION_STEP = 10;
export const DEFAULT_CUSTOM_PRODUCTION = 50;

export const ESTIMATE_DEBOUNCE_MS = 300;
